export default {
    "navigation": {
        "allWatchfaces": "Todas as apps",
        "faq": "FAQ",
        "helpCenter": "Ajuda e instruções",
        "newsletter": "Newsletter",
        "contact": "Contacto",
        "weatherProvider": "Provedor do Clima",
        "tides": "Marés",
        "colors": "Cores",
        "fonts": "Fontes"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "Apps Garmin modernas com funcionalidades avançadas para todas as suas atividades",
        "newBadge": "Novo",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "Perguntas frequentes",
        "subtitle": "Encontre respostas para perguntas comuns sobre nossos watchfaces",
        "tabs": {
            "search": "Pesquisar",
            "categories": "Categorias",
            "trending": "Tendências"
        },
        "search": {
            "placeholder": "Pesquisar ajuda...",
            "button": "Pesquisar",
            "suggestions": "Pesquisas populares",
            "tips": {
                "title": "Dicas de pesquisa",
                "keywords": "Use palavras-chave específicas como \"GPS\", \"clima\" ou \"configurações\"",
                "language": "A pesquisa funciona no seu idioma selecionado",
                "categories": "Navegue pelas categorias para ajuda organizada"
            }
        },
        "noResults": {
            "title": "Nenhum resultado encontrado",
            "description": "Tente palavras-chave diferentes ou navegue pelas categorias",
            "browseCategories": "Navegar por categorias"
        },
        "suggestions": {
            "title": "Pesquisas populares"
        },
        "trending": {
            "title": "Pesquisas em tendência"
        },
        "categories": {
            "title": "Navegar por categoria",
            "items": "itens",
            "allItems": "Todos os itens FAQ",
            "allItemsDescription": "Navegue todas as perguntas frequentes",
            "noItems": {
                "title": "Nenhum item nesta categoria",
                "description": "Tente selecionar uma categoria diferente"
            },
            "viewMore": "Ver todos os itens"
        },
        "results": {
            "title": "Resultados da pesquisa",
            "found": "resultados encontrados para",
            "total": "Total de resultados",
            "bestMatch": "Melhor correspondência",
            "categories": "Categorias",
            "sortBy": "Ordenar por",
            "sort": {
                "relevance": "Relevância",
                "priority": "Prioridade",
                "category": "Categoria"
            },
            "lastUpdated": "Última atualização",
            "matchedIn": "Correspondência em",
            "footer": "Não encontrou o que estava procurando?",
            "browseCategories": "Navegar por categorias",
            "viewTrending": "Ver tendências",
            "contactSupport": "Contatar suporte"
        },
        "actions": {
            "copy": "Copiar",
            "share": "Compartilhar",
            "copyAnswer": "Copiar resposta",
            "copyAll": "Copiar tudo"
        },
        "loading": "Carregando FAQ...",
        "error": "Erro de carregamento",
        "retry": "Tentar novamente"
    },
    "guides": {
        "backToHelp": "Voltar",
        "purchase": {
            "title": "Compra e instalação",
            "tabs": {
                "installation": "Instalação",
                "versions": "Versões VX / Elite",
                "troubleshooting": "Resolução de problemas"
            },
            "installation": {
                "title": "Instalar watchfaces através da app ConnectIQ",
                "intro": "Os watchfaces podem ser instalados no relógio através da app Garmin ConnectIQ para Android ou iOS.",
                "step1": "Ligue o relógio ao telemóvel via Bluetooth e abra a app ConnectIQ no telemóvel.",
                "step2": "Navegue até à página do watchface que deseja instalar.",
                "step3": "Toque no botão \"Instalar\". O watchface será colocado na fila de transferência e instalado no seu relógio.",
                "step4": "Após a instalação verá uma mensagem na app ou no relógio e o watchface ficará disponível no seu dispositivo.",
                "noteScreen": "Certifique-se de que o ecrã do telemóvel não desliga e que a app ConnectIQ permanece aberta durante a instalação e atualizações.",
                "selectWatchfaceTitle": "Selecionar o watchface no relógio",
                "selectWatchfaceIntro": "Se o watchface está instalado mas ainda não visível, pode ser necessário selecioná-lo no menu de sistema do relógio.",
                "select1": "Prima e segure o botão de menu no relógio (ou o botão correspondente em dispositivos com ecrã tátil) para abrir o menu de sistema.",
                "select2": "Navegue até ao item \"Mostradores\" ou \"Designs de ecrã\".",
                "select3": "Verá uma lista de todos os watchfaces instalados. Use os botões cima/baixo ou o ecrã tátil para navegar.",
                "select4": "Confirme o watchface selecionado com o botão superior direito. O watchface está agora ativo no seu relógio."
            },
            "versions": {
                "title": "VX vs Elite – qual é a diferença?",
                "sameFeatures": "Tecnicamente, ambas as versões são idênticas e oferecem as mesmas funcionalidades. A única diferença é a forma de compra e ativação.",
                "eliteTitle": "Versão Elite (Garmin Pay)",
                "elite1": "Instalação separada do watchface comprado diretamente via Garmin Pay na Loja ConnectIQ.",
                "elite2": "A versão Elite está associada à sua conta Garmin. Se comprar um relógio novo, pode reinstalar o watchface Elite sem uma chave extra.",
                "elite3": "O Garmin Pay não é suportado em todos os modelos de relógio e pode não estar disponível em todos os países.",
                "eliteNoKey": "Importante: Ao comprar uma versão Elite via Garmin Pay, não é enviado nenhum código de desbloqueio. A versão Elite é desbloqueada diretamente após a compra e não requer código.",
                "vxTitle": "Versão VX / Website",
                "vx1": "Compatível com um maior número de dispositivos e muitas vezes disponível mesmo quando o Garmin Pay não está.",
                "vx2": "Inclui um período de teste gratuito de vários dias.",
                "vx3": "Após o período de teste, pode comprar um código de desbloqueio neste site para desbloquear permanentemente a versão VX (ou as suas funcionalidades pro).",
                "vx4": "O código de desbloqueio é válido apenas para o dispositivo para o qual foi comprado (WatchfaceID).",
                "vx5": "Se o relógio for substituído pela Garmin em garantia, pode ser gerada uma nova chave. Nesse caso, contacte o suporte através do formulário de contacto."
            },
            "website": {
                "title": "Compra via website (versões VX / normais)",
                "step1": "Instale primeiro o watchface no relógio (ver separador Instalação). O WatchfaceID só aparece nas definições do watchface após a instalação.",
                "step2": "Abra as definições do watchface (via app ConnectIQ ou Garmin Express) e copie o WatchfaceID do campo superior.",
                "step3": "Neste website, selecione o watchface correspondente e introduza o seu WatchfaceID no formulário de compra.",
                "step4": "Conclua o pagamento. Receberá o código de desbloqueio por email e pode introduzi-lo no campo da chave nas definições do watchface.",
                "noteNoAutoInstall": "Importante: A compra de um código de desbloqueio via website não instala automaticamente o watchface no relógio. Os passos de instalação acima devem ser concluídos manualmente."
            },
            "troubleshooting": {
                "installationTitle": "Problemas de instalação (fila / atualizações presas)",
                "installationIntro": "Por vezes a instalação falha, o watchface fica na fila durante muito tempo ou a app ConnectIQ reporta atualizações infinitas.",
                "installationCause": "Isto está normalmente relacionado com a app ConnectIQ ou serviços Garmin e não com o watchface em si.",
                "installationFix1": "Reinicie o relógio e reinicie a app ConnectIQ no telemóvel.",
                "installationFix2": "Tente a instalação novamente e certifique-se de que o ecrã do telemóvel não desliga e a app ConnectIQ permanece aberta durante o processo.",
                "garminPayTitle": "Compra Garmin Pay presa \"em progresso\"",
                "garminPayText": "Se uma compra Garmin Pay na loja ConnectIQ ficar presa em \"em progresso\" durante muito tempo, isto é tratado inteiramente pela Garmin. Como programadores, não temos influência no sistema Garmin Pay. Nesse caso, contacte o suporte oficial Garmin.",
                "noKeyTitle": "Não recebi a chave de desbloqueio após a compra no website",
                "noKey1": "Primeiro, verifique a pasta de spam da sua caixa de correio. Os emails com chaves acabam muitas vezes lá.",
                "noKey2": "Em muitos casos, um erro no endereço de email impede a entrega. Se não encontrar o email, contacte-nos.",
                "noKey3": "e inclua o endereço de email que usou para o pagamento e, se possível, o WatchfaceID.",
                "noKeyElite": "Nota: Ao comprar uma versão Elite diretamente via Garmin Pay na loja ConnectIQ, não é enviado nenhum código de desbloqueio. A versão Elite é desbloqueada imediatamente após a compra e não requer código."
            },
            "contactLink": "Formulário de contacto"
        },
        "timezones": {
            "title": "Fusos horários e offset UTC",
            "basicsTitle": "O que são o 2.º e 3.º fusos horários?",
            "basicsText": "Em muitos watchfaces pode configurar dois fusos horários adicionais. São normalmente chamados \"Segundo fuso horário\" e \"Terceiro fuso horário\" e são mostrados em campos dedicados no mostrador.",
            "offsetTitle": "Configurar os offsets UTC",
            "offsetIntro": "Nas definições do watchface há normalmente um campo onde pode introduzir os offsets do segundo e terceiro fusos horários em minutos relativamente ao UTC.",
            "offsetFormat": "O primeiro valor é o offset do segundo fuso, o segundo valor é o offset do terceiro. Os valores são dados em minutos, separados por um espaço. O sinal + não é adicionado automaticamente, pelo que valores positivos devem ser introduzidos sem +.",
            "exampleLabel": "Exemplo:",
            "exampleExplanation": "Aqui o segundo fuso usa um offset de -4,5 horas (−270 minutos) e o terceiro um offset de +2 horas (+120 minutos), sempre relativamente ao UTC.",
            "changeExample": "Se quiser alterar o segundo fuso para +6 horas, o primeiro valor deve ser 360 (6 × 60). Com o exemplo acima resultaria em:",
            "advancedTitle": "Opções avançadas (sufixo A/B/C)",
            "advancedOptionalHint": "Esta secção é opcional. Só é relevante se o seu watchface suportar os sufixos A/B/C.",
            "advancedIntro": "Se o watchface suporta estes sufixos está indicado na descrição por cima do campo de offset nas definições do watchface. Nesse caso pode ver uma descrição semelhante a:",
            "advancedExample": "Offset UTC 2.º e 3.º fusos em minutos (separar com espaço) (letras após os offsets: A - formato 12h, B - formato 24h, C - formato militar, vazio - standard)",
            "advancedNote": "Estas letras opcionais (A/B/C) controlam o formato de exibição do respetivo fuso em alguns watchfaces. Use-as apenas se a descrição do watchface as mencionar.",
            "exampleSectionTitle": "Passo a passo: Exemplo para diferentes cidades e formatos",
            "exampleIntro": "O exemplo seguinte mostra como definir uma 2.ª zona (ex.: Nova Iorque) e uma 3.ª (ex.: Tóquio), e opcionalmente 12h ou 24h para cada uma.",
            "exampleStep1Title": "Passo 1: Offset UTC para a 2.ª zona",
            "exampleStep1Text": "Escolha a cidade ou região para a 2.ª zona. Converta a diferença em relação ao UTC em minutos. Ex.: Nova Iorque (EST, UTC−5) → −300 minutos. Introduza este valor em primeiro lugar no campo.",
            "exampleStep2Title": "Passo 2: Offset UTC para a 3.ª zona",
            "exampleStep2Text": "O mesmo para a 3.ª zona. Ex.: Tóquio (JST, UTC+9) → 540 minutos. É o segundo valor, separado por um espaço do primeiro.",
            "exampleOnlyOffsets": "Se o watchface não usar sufixos A/B/C, está pronto. Introduza:",
            "exampleStep3Title": "Passo 3: Sufixo de formato opcional (A/B/C)",
            "exampleStep3Optional": "Este passo é opcional: pode omitir os sufixos mesmo que o watchface os suporte; será usado o formato por defeito. Para forçar 12h, 24h ou militar por zona, adicione a letra logo a seguir ao offset, sem espaço.",
            "exampleStep3Text": "Exemplo: formato 12h para Nova Iorque (A) e 24h para Tóquio (B):",
            "exampleStep3Note": "Sem sufixo = formato por defeito do watchface (geralmente 24h). Se os sufixos são suportados está indicado na descrição por cima do campo de offset nas definições.",
            "exampleFormatTitle": "Como a hora é mostrada com A, B, C",
            "exampleFormatIntro": "Para o mesmo instante, a exibição varia consoante o formato (ex.: 2.ª zona Nova Iorque -300, 3.ª zona Tóquio 540). Pré-visualização em direto:",
            "zone2": "2.ª zona",
            "zone3": "3.ª zona",
            "exampleTableTitle": "Referência: Offsets UTC para algumas cidades (minutos)",
            "exampleTableIntro": "Hora legal; o horário de verão pode diferir. Multiplique as horas por 60."
        },
        "switchViews": {
            "title": "Vistas alternativas e controlo por gestos",
            "wordLabel": "vista alternativa",
            "basicsTitle": "O que são as vistas alternativas?",
            "basicsText": "Muitos watchfaces podem mostrar informações diferentes na mesma área do ecrã. Estas páginas alternativas são muitas vezes chamadas \"Switchview\" ({{wordLabel}}), \"Switchview 2\", \"Vista superior 1/2\", \"Vista inferior 1/2\" ou similar nas definições.",
            "proNote": "Em muitos casos estas vistas adicionais são funcionalidades pro disponíveis durante o período de teste e requerem uma chave de ativação depois.",
            "gestureTitle": "Mudar vistas com um gesto do pulso",
            "gestureIntro": "Em relógios sem ecrã tátil compatível, as vistas alternativas podem ser mudadas com um segundo movimento do pulso.",
            "gestureStep1": "Levante o pulso como habitualmente para acordar o ecrã. Os segundos ou o ecrã iluminado indicam que o relógio está em modo ativo.",
            "gestureStep2": "Em poucos segundos (cerca de 7), faça o movimento do pulso novamente – não demasiado brusco, mas suficientemente claro para o relógio reconhecer.",
            "gestureStep3": "Se o watchface suportar vistas alternativas, as áreas configuradas (ex. vista superior ou inferior) mudarão para a página seguinte.",
            "gestureHint": "Se nada mudar, verifique as definições: algumas vistas têm de ser atribuídas explicitamente (ex. \"Vista superior 2\" / \"Vista inferior 2\").",
            "touchTitle": "Vistas alternativas em dispositivos com ecrã tátil",
            "touchIntro": "Em relógios mais recentes com ecrã tátil compatível (ex. Fenix 7 e mais recentes), as vistas podem muitas vezes ser mudadas tocando em zonas específicas.",
            "touchConfig": "Em muitos watchfaces pode configurar estas zonas nas definições, muitas vezes mais abaixo. Exemplos típicos são os dígitos das horas e minutos ou áreas separadas no ecrã.",
            "touchHold": "Se uma zona tátil estiver configurada, um toque prolongado no dígito/área respetivo muda a vista atribuída.",
            "touchMultiple": "Alguns watchfaces oferecem várias zonas que podem ser atribuídas separadamente – por exemplo uma para a vista superior e outra para a inferior.",
            "touchInfo": "Se existirem zonas especiais para um watchface, são normalmente descritas no texto informativo no website ou na Loja ConnectIQ."
        },
        "findWfId": {
            "title": "Como encontrar o seu WatchfaceID",
            "whatIs": "O que é o WatchfaceID?",
            "whatIsExplanation": "Cada watchface tem um WatchfaceID individual por dispositivo. É um número de 5-6 dígitos. Este ID é necessário para comprar um código de ativação ou para fins de suporte.",
            "connectIqTitle": "Via app ConnectIQ (recomendado)",
            "ciq1": "Certifique-se de que o relógio está ligado ao telemóvel via Bluetooth.",
            "ciq2": "Abra a app ConnectIQ no telemóvel.",
            "ciq3": "Navegue até à página do watchface onde vê a descrição e imagens. Se não encontrar, use a barra \"Pesquisar\" em baixo ou procure em \"Os meus mostradores\" na secção \"Dispositivo\".",
            "ciq4": "Prima o botão \"Definições\" na página do watchface para abrir todas as definições.",
            "ciq5": "O WatchfaceID está no campo superior. Copie ou escreva este número – é o ID necessário para o pagamento.",
            "keyEntryTitle": "Introduzir a chave de ativação",
            "keyEntryExplanation": "Na linha abaixo do campo WatchfaceID encontrará o campo para a chave/código enviado após o pagamento. Alguns watchfaces mostram aí os dias de teste restantes – apague antes de introduzir a sua chave.",
            "garminExpressTitle": "Via Garmin Express (computador)",
            "ge1": "Instale o Garmin Express e ligue o relógio ao computador.",
            "ge2": "Vá à lista de watchfaces instalados.",
            "ge3": "Clique no botão de três pontos ao lado do watchface para abrir as definições.",
            "ge4": "Siga os mesmos passos que na app ConnectIQ.",
            "geNote": "Nota: A app ConnectIQ é recomendada, pois algumas versões do Garmin Express podem causar erros.",
            "zeroId": "O WatchfaceID mostra 0?",
            "zeroIdExplanation": "Por vezes o WatchfaceID mostra 0. Isto pode normalmente ser corrigido guardando as definições uma vez ou reiniciando o relógio. Se continuar a mostrar 0, deve funcionar na mesma para o pagamento."
        },
        "location": {
            "title": "Configuração GPS e localização",
            "whatIsGpsFix": "O que é um fix GPS?",
            "gpsFixExplanation": "Um fix GPS indica ao watchface onde está para que possa calcular corretamente horários de nascer/pôr do sol, fases da lua, localização do tempo e marés.",
            "howTo": "Como fazer um fix GPS",
            "step1": "No relógio, navegue até ao ecrã de início de qualquer atividade (ex. \"Corrida\")",
            "step2": "Aguarde até o relógio adquirir o sinal GPS (barra/ícone verde)",
            "step3": "Volte ao mostrador – os dados devem atualizar em poucos minutos",
            "alternative": "Alternativa: GPS do telemóvel",
            "alternativeExplanation": "Também pode ativar o GPS no telemóvel. O relógio deve estar ligado via Bluetooth. Este método é mais lento mas funciona igualmente.",
            "requirements": "Requisitos",
            "req1": "Relógio ligado ao telemóvel via Bluetooth",
            "req2": "App Garmin Connect (não ConnectIQ) a correr pelo menos em segundo plano",
            "req3": "GPS ativado no telemóvel para localização baseada no telemóvel"
        },
        "settings": {
            "tabs": { "options": "Opções de campos de dados", "change": "Alterar definições", "troubleshoot": "Resolução de problemas" },
            "title": "Definições do watchface",
            "optionsIntro": "Lista geral de opções de campos de dados. Clique para ver a descrição. Nem todas as opções estão disponíveis em todos os watchfaces.",
            "change": {
                "title": "Como alterar as definições do watchface",
                "intro": "As definições do watchface alteram-se na app ConnectIQ no telemóvel.",
                "step1": "Ligue o relógio ao telemóvel por Bluetooth e abra a app ConnectIQ (não a Connect).",
                "step2": "Vá à página do watchface. Se ainda não estiver instalado, instale primeiro.",
                "step3": "Na página do watchface verá o botão \"Definições\"; toque para abrir a lista.",
                "step4": "Aqui pode alterar campos de dados, cores e opções avançadas.",
                "step5": "Toque no botão guardar no canto superior direito para transferir as definições para o relógio.",
                "installLink": "Guia de instalação"
            },
            "troubleshoot": {
                "title": "Resolução de problemas",
                "cantSave": { "q": "As definições não se guardam", "a1": "Por vezes os servidores Garmin têm problemas com certos caracteres.", "a2": "Esvazie o campo do tema de cor (se existir) e guarde de novo." },
                "wontOpen": { "q": "As definições não abrem", "a1": "Feche completamente a app ConnectIQ e reinicie o relógio se necessário.", "a2": "Se só vir o botão \"Instalar\", o watchface ainda não está instalado." },
                "missingOptions": { "q": "Não encontro uma opção de definição", "a": "Nem todas as opções estão disponíveis em todos os dispositivos." },
                "naValue": { "q": "Um campo mostra apenas \"n/a\"", "a": "O dispositivo não suporta esta opção (modelo antigo ou hardware em falta)." }
            }
        },
        "dateFormat": {
            "title": "Formato de data personalizado (Data 1 / 2 / 3)",
            "basicsTitle": "O que são os campos de formato de data?",
            "basicsIntro": "Nas definições do watchface há dois campos (ou três) para configurar como a Data 1, Data 2 e opcionalmente Data 3 são mostradas. As letras que introduz definem o formato.",
            "notAll": "Não disponível em todos os watchfaces.",
            "where": "Os campos ficam em geral mais abaixo nas definições, abaixo das opções de campos de dados.",
            "codesTitle": "Códigos de formato",
            "codesIntro": "Pode usar as seguintes letras. O resultado reflete a data atual.",
            "codeD": "dia do mês (com zero inicial)",
            "codeDText": "dia em texto (ex. segunda)",
            "codeM": "mês em número (com zero inicial)",
            "codeMText": "mês em texto",
            "codeY": "ano dois dígitos",
            "codeY4": "ano quatro dígitos",
            "codeJ": "data juliana (militar)",
            "codeW": "número da semana",
            "codeO": "mês sem zero inicial",
            "codeN": "dia sem zero inicial",
            "codeP": "dia do ano",
            "exampleHint": "Ex.: \"D, d.M.Y\" pode mostrar \"Seg, 27.02.2026\"."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Como funcionam os temas?:",
            "description": "No topo das definições do watchface tem uma \"cadeia de tema\" que representa as definições de cor atuais (ícones, gráfico, hora, etc.) do seu watchface. Se alterar algo (como a cor da secção superior) e premir \"Guardar\", a cadeia de tema atualiza-se na próxima vez que abrir as definições. Assim pode guardar as definições de cor copiando e guardando a cadeia noutro sítio. Pode até partilhá-la com outras pessoas (ex. nas avaliações/fórum) e aplicar cadeias de outras pessoas para experimentar outros estilos."
        },
        "dynamicThemeSwitching": {
            "title": "Mudança dinâmica de tema:",
            "sunset": {
                "title": "Mudar após o pôr do sol / antes do nascer do sol -",
                "description": "se colocar um ponto de exclamação ! à frente da cadeia de tema que quer usar no campo da cadeia de tema, será guardada como o tema para o qual mudar após o pôr do sol (exemplo: !UEUE[UEUEEEEEEU^). Pode alterá-la quando quiser colocando uma cadeia com ! à frente no campo. Para eliminar o tema noturno, coloque apenas ! no campo e não mudará mais."
            },
            "lowPower": {
                "title": "Mudar em modo de baixo consumo -",
                "description": "é o mesmo processo que definir um tema para pôr/nascer do sol acima, mas em vez de ! coloque um # à frente da sua cadeia de tema (exemplo: #UEUE[UEUEEEEEEU^). Cada relógio entra em \"Modo de baixo consumo\" após cerca de 10 segundos a olhar para o relógio ou ao voltar de um menu. Normalmente os segundos desaparecem em baixo consumo por defeito (pode ser alterado nas definições do watchface). Ambas as opções (@noite/@baixoConsumo) podem ser combinadas. Uma vez definida, uma cadeia de tema dinâmica não é visível nas definições do watchface, por isso guarde-a noutro sítio se quiser fazer alterações no futuro."
            }
        }
    },
    "helpCenter": {
        "title": "Ajuda e instruções",
        "subtitle": "Respostas, guias e instruções para o seu watchface",
        "guidesTitle": "Guias e instruções",
        "faqTitle": "Perguntas frequentes",
        "allCategories": "Tudo",
        "guides": "Guias",
        "faqResults": "FAQ",
        "noResults": "Nenhum resultado encontrado",
        "noResultsHint": "Tente outras palavras-chave ou navegue pelas categorias e guias abaixo."
    },
    "watchfacesOverview": {
        "title": "Todas as apps",
        "loading": "A carregar watchfaces...",
        "error": "Erro ao carregar watchfaces",
        "retry": "Tentar novamente",
        "noWatchfaces": "Nenhum watchface disponível"
    },
    "detailTabs": {
        "payment": "Pagamento",
        "themes": "Temas",
        "info": "Info",
        "instructions": "Instruções",
        "instructionsIntro": "Todos os guias e instruções de relance:",
        "noThemes": "Nenhum tema de cor disponível para este watchface."
    },
    "watchfaceDetail": {
        "loading": "A carregar watchface...",
        "error": {
            "notFound": "Watchface não encontrado",
            "loading": "Erro ao carregar o watchface"
        },
        "backToOverview": "Voltar à visão geral",
        "goToStore": "Ir para o IQ Store",
        "goToTrial": "Versão de teste",
        "devices": "dispositivos",
        "info": {
            "title": "Funcionalidades",
            "tides": "🌊 Informação de marés com atualizações automáticas",
            "weather": "🌤️ Dados meteorológicos de OpenWeatherMap e Yr",
            "colors": "🎨 Temas de cor e personalizações",
            "location": "📍 Localização por GPS",
            "faq": "❓ FAQ e suporte",
            "weatherFallback": "Sem subscrição One Call 3.0, a chave API OpenWeatherMap usa o fornecedor \"Yr\" como reserva."
        }
    },
    "colorThemes": {
        "clickToCopy": "Clique para copiar",
        "clickToPreview": "Clique para pré-visualizar",
        "closePreview": "Fechar pré-visualização",
        "copied": "Copiado!",
        "useInSettings": "Use nas definições do seu watchface",
        "guideLink": "Mais informações sobre temas e strings de tema",
        "deviceNote": "Os temas de cor não estão disponíveis em todos os dispositivos.",
        "noFieldNote": "Se as definições do seu watchface não tiverem um campo separado para os esquemas de cores, estes não são suportados para o seu modelo de relógio neste watchface."
    },
    "payment": {
        "option1": {
            "title": "Opção 1: Garmin Pay",
            "description": "Compre o watchface pago via Garmin Pay na ConnectIQ Store (se o seu relógio for suportado).",
            "link": "Ligação para a ConnectIQ Store"
        },
        "option2": {
            "title": "Opção 2: Pagamento direto com WatchfaceID",
            "description": "Se o seu relógio não for suportado pela versão Pro, pode comprar uma chave Trial/VX introduzindo a sua WatchfaceID.",
            "vxNote": "Esta é uma chave para a versão VX do watchface, não a versão Garmin Pay!",
            "vxLink": "Ligação para a versão VX"
        },
        "tax": "IVA",
        "wfid": {
            "description": "Introduza a sua WatchfaceID (nas definições do watchface)",
            "placeholder": "Introduza WatchfaceID (5-6 dígitos)",
            "guideLink": "Como encontrar a sua WatchfaceID",
            "guideLinkShort": "Mostrar instruções"
        },
        "wfidError": {
            "letters": "A WatchfaceID deve conter apenas números",
            "tooLong": "A WatchfaceID deve ter 5-6 dígitos",
            "invalid": "Introduza uma WatchfaceID válida (5-6 dígitos)",
            "lengthHint": "Uma WatchfaceID tem normalmente 5-6 dígitos. Verifique."
        },
        "errors": {
            "empty": "Introduza a sua WatchfaceID",
            "invalid": "Introduza uma WatchfaceID válida",
            "config": "Erro de configuração do pagamento",
            "checkout": "Não foi possível abrir o pagamento. Tente novamente."
        },
        "buy": "Comprar agora",
        "selectMethod": "Escolha a sua versão",
        "versionSelectHint": "Estas são duas versões separadas — por favor selecione a correta:",
        "vxWarning": "As versões VX e Elite são versões transferíveis separadamente do mostrador. Um código de ativação para a versão VX NÃO desbloqueia a versão Elite.",
        "beta": {
            "title": "Atualmente em beta",
            "description": "Durante esta fase beta você pode usar este watchface totalmente de graça. Nenhuma cobrança automática será feita após o período de testes. Novas funções e melhorias estão sendo testadas durante este tempo. Obrigado pelo seu feedback!",
            "descriptionApp": "Durante esta fase beta, pode usar esta app completamente de forma gratuita. Após o período de teste não haverá cobranças automáticas. Nesta fase estão a ser testadas novas funcionalidades. Obrigado pelo vosso feedback!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Versão Elite",
            "description": "Este watchface está disponível apenas via Garmin Pay na ConnectIQ Store.",
            "comboDescription": "Compre via Garmin Pay na ConnectIQ Store. Versão separada e independente.",
            "compatibility": "Garmin Pay não é suportado em todos os relógios. Verifique a compatibilidade na página Store. Caso contrário, transfira a versão VX (tecnicamente idêntica).",
            "storeLink": "Abrir na ConnectIQ Store",
            "moreGuide": "Precisa de mais detalhes sobre a diferença Elite / VX?",
            "moreGuideLink": "Ler o guia de compra e instalação",
            "eliteNoKey": "Ao comprar uma versão Elite via Garmin Pay, não é enviado nenhum código de desbloqueio. A versão Elite fica desbloqueada diretamente após a compra e não requer código.",
            "accountBound": "A compra via Garmin Pay está vinculada à sua conta Garmin e fica automaticamente disponível para os seus futuros dispositivos (se compatíveis).",
            "eliteNoKeyAndGuide": "Ao comprar via Garmin Pay não é enviado código de desbloqueio — a versão Elite fica desbloqueada diretamente após a compra. Mais detalhes no guia de compra e instalação."
        },
        "vx": {
            "badge": "Todos os dispositivos",
            "title": "Versão VX",
            "description": "Compatível com todos os dispositivos suportados. Transfira a versão de teste da ConnectIQ Store e ative-a aqui com um código comprado.",
            "trialNote": "A versão VX inclui um período de teste. Depois, compre um código de ativação abaixo para desbloquear.",
            "deviceBound": "Um código de ativação está vinculado ao seu dispositivo e desbloqueia a versão VX permanentemente.",
            "moreGuide": "Precisa de mais detalhes sobre a versão VX, chaves ou instalação?",
            "moreGuideLink": "Ler o guia de compra e instalação",
            "downloadLink": "Transferir versão VX",
            "details": {
                "line1": "Após o pagamento, a chave de ativação será enviada para o e-mail que indicar no próximo passo.",
                "line2": "Certifique-se de que o e-mail está correto.",
                "line3": "Verifique a pasta de spam após o pagamento; e-mails com chaves costumam ir para lá.",
                "line4": "Todos os pagamentos são processados pela Paddle; não é necessária conta.",
                "line5": "Para suporte, use o formulário de contacto ou a ferramenta ConnectIQ Store.",
                "line6": "Outros pedidos não podem ser processados."
            }
        },
        "standalone": {
            "title": "Comprar código de ativação",
            "description": "Compre um código de ativação introduzindo a sua WatchfaceID abaixo. O código será enviado de imediato."
        },
        "checkoutOpening": "A abrir pagamento...",
        "info": {
            "key": "Após a compra receberá uma chave para introduzir nas definições do watchface.",
            "activation": "A chave é ativada imediatamente após o pagamento.",
            "support": "Para dúvidas, contacte o suporte.",
            "moreGuide": "Mais sobre compra e instalação"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Cartão de crédito"
        }
    },
    "footer": {
        "tagline": "Apps Garmin modernas com funcionalidades avançadas para todas as atividades.",
        "description": "Apps Garmin modernas com funcionalidades avançadas para todas as atividades."
    },
    "newsletter": {
        "title": "Newsletter",
        "description": "Subscreva a newsletter para novidades sobre novos watchfaces, funcionalidades e promoções.",
        "frequencyHint": "Aproximadamente um email de dois em dois meses. Pode cancelar a subscrição a qualquer momento.",
        "emailPlaceholder": "O seu endereço de email",
        "subscribe": "Subscrever",
        "unsubscribe": "Cancelar subscrição",
        "subscribeSuccess": "Subscrição efetuada! Verifique o seu email.",
        "subscribeError": "Ocorreu um erro. Tente novamente mais tarde.",
        "unsubscribeSuccess": "Subscrição cancelada.",
        "unsubscribeError": "Ocorreu um erro. Tente novamente mais tarde."
    },
    "contact": {
        "title": "Contacto",
        "description": "Tem alguma pergunta ou precisa de ajuda? Envie-me uma mensagem.",
        "emailLabel": "E-mail",
        "emailPlaceholder": "o.seu@email.pt",
        "deviceLabel": "Dispositivo (opcional)",
        "devicePlaceholder": "ex.: Fenix 7",
        "watchfaceLabel": "Watchface (opcional)",
        "watchfacePlaceholder": "ex.: Horizon",
        "messageLabel": "Mensagem",
        "messagePlaceholder": "A sua mensagem...",
        "send": "Enviar mensagem",
        "sendAnother": "Enviar outra mensagem",
        "successTitle": "Mensagem enviada!",
        "successMessage": "Responderei assim que possível.",
        "error": "Ocorreu um erro. Tente novamente ou envie diretamente um email para dev@orcatec.net.",
        "rateLimit": "Máximo de 2 mensagens a cada 5 minutos. Tente novamente mais tarde.",
        "consentNotice": "Ao enviar, aceita o tratamento dos seus dados de acordo com a minha",
        "guidesIntro": "Se tiver dúvidas sobre funcionalidades específicas, estes guias podem já ter a resposta:",
        "faqIntro": "Para muitos temas existe também uma FAQ detalhada:",
        "faqLinkLabel": "Abrir Ajuda e instruções",
        "responseTimeNotice": "Agradeço a compreensão: em épocas de maior volume de trabalho a resposta pode demorar alguns dias."
    },
    "fonts": {
        "title": "Fontes",
        "timefonts": "Fontes de hora",
        "datafonts": "Fontes de dados"
    },
    "common": {
        "loading": "Carregando...",
        "error": "Erro",
        "retry": "Tentar novamente",
        "back": "Voltar",
        "close": "Fechar",
        "save": "Salvar",
        "cancel": "Cancelar",
        "confirm": "Confirmar",
        "notFound": "404 – Página não encontrada"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "A app Bierwandern permite registar a sua caminhada e as recargas que aprecia pelo caminho. Além disso, inclui uma estimativa de álcool no sangue com gráfico (estimativa aproximada) – mas não leve demasiado a sério!",
        "settingsHint": "No ecrã inicial, prima o botão de menu do relógio para abrir as definições (em relógios com layout de 2 botões, mantenha premido o ecrã tátil).",
        "disclaimer": "O cálculo do álcool no sangue é uma métrica puramente divertida – um algoritmo que estima o álcool com base nas bebidas consumidas e no peso corporal! Não tome decisões com base neste valor; não é fiável e não é uma medição real do álcool!",
        "closing": "De resto, desejo-lhe boas caminhadas e um bom momento!",
        "support": "Para problemas ou sugestões de melhoria, use o botão «App Support» – obrigado."
    },
    "bodysurf": {
        "intro": {
            "title": "O que é BodySurf?",
            "text": "BodySurf é uma app Garmin Connect IQ para bodysurf. Usa GPS para detetar quando surfa uma onda, mede distância e duração de cada ride e atribui um título divertido conforme a distância. As sessões são guardadas como atividades com voltas individuais no Garmin Connect."
        },
        "gps": {
            "title": "Antes de começar – GPS",
            "text1": "Aguarde pelo fix GPS antes de iniciar uma sessão. No ecrã inicial verá \"Buscando GPS\" até haver sinal, depois \"START para começar\".",
            "text2": "Para melhor precisão a app usa GPS multi-GNSS / dual-band se o relógio suportar. Fique parado um momento junto à água se o fix demorar."
        },
        "start": {
            "title": "Tela de Início",
            "startBtn": "Inicie uma nova sessão quando o GPS estiver pronto (START = iniciar sessão).",
            "menuBtn": "Abra definições: Como usar e Unidades (MENU = configurações / info).",
            "backBtn": "BACK = sair do app"
        },
        "during": {
            "title": "Durante a Atividade",
            "detect": "Cavalgadas são detectadas por GPS velocidade automaticamente. Use BACK para iniciar/parar uma cavalgada manualmente. Movimentos curtos abaixo de cerca de 2 metros são descartados.",
            "startBtn": "START = parar / salvar / retomar",
            "backBtn": "BACK = cavalgada manual on/off",
            "live": "Enquanto surfa vê a distância atual, um título em direto e \"CAVALGANDO!\". Após um ride o título e estatísticas permanecem até ao seguinte."
        },
        "stop": {
            "title": "Menu de paragem",
            "resume": "Retomar",
            "save": "Salvar",
            "discard": "Descartar"
        },
        "after": {
            "title": "Após a Sessão",
            "summary": "O resumo mostra tempo de sessão, número de Cavalgadas, distância total e o ride Melhor com título e estatísticas.",
            "rides": "Deslize para ver detalhes da cavalgada. Em relógios com botões: << DOWN rides.",
            "finished": "Depois: Nova Sessão com START ou Sair do App com VOLTAR."
        },
        "titles": {
            "title": "Títulos de ride",
            "intro": "Cada cavalgada recebe um título divertido baseado na distância. Quanto mais longa a cavalgada, melhor o título!",
            "colDistance": "Distância",
            "colTitle": "Título",
            "th0": "Seegurke",
            "th1": "Flunder",
            "th2": "Prancha Humana",
            "th3": "Wellenreiter",
            "th4": "Aquaman",
            "th5": "Poseidon",
            "th6": "Netuno",
            "th7": "Dominador das Ondas",
            "th8": "Mestre das Ondas",
            "th9": "Deus das Ondas",
            "th10": "Lenda do Oceano",
            "th11": "Titã das Ondas",
            "th12": "Rei do Oceano"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Sessões guardadas aparecem no Garmin Connect com campos personalizados: título do ride, distância da volta (metros), tempo da volta (segundos) e ride/tempo mais longos ao nível da sessão. Cada ride detetado é guardado como volta."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "No Instinct o subdisplay mostra hora, GPS e distância. Use o botão BAIXO em vez de deslizar (<< DOWN rides).",
            "menu": "\"Menu\" aparece à esquerda no ecrã inicial. Pressione START quando GPS OK aparece no subdisplay."
        },
        "settings": {
            "title": "Definições",
            "units": "Unidades: alterne entre métrico e imperial para distância e velocidade no relógio.",
            "info": "Info: ajuda integrada (Como usar) para botões durante atividade, após sessão e ecrã inicial."
        },
        "supportBefore": "Para problemas ou sugestões use o",
        "supportLink": "formulário de contacto",
        "supportAfter": " – obrigado!"
    }
};
